export const MISSIONS = [
  {
    name: "Bifrost Bridge Patrol",
    description: "Guard the rainbow bridge connecting the realms from potential threats.",
    backgroundId: "nineRealms",
    energyCost: 5,
    requirements: {
      maxStat: { type: "DEF", value: 1000, current: 1200 },
      totalStat: { type: "HP", value: 50000, current: 85000 }
    },
    rewards: [
      { type: "gems", amount: 150 },
      { type: "shards", amount: 50 }
    ]
  },
  {
    name: "Yggdrasil Essence Collection",
    description: "Harvest magical essence from the World Tree's branches.",
    energyCost: 5,
    backgroundId: "earth",
    requirements: {
      maxStat: { type: "ATK", value: 1500, current: 1700 },
      totalStat: { type: "DEF", value: 2000, current: 2200 }
    },
    rewards: [
      { type: "shards", amount: 100 },
      { type: "gems", amount: 75 }
    ]
  },
  {
    name: "Muspelheim Fire Taming",
    description: "Contain the eternal flames of the fire giants' realm.",
    energyCost: 5,
    backgroundId: "earth",
    requirements: {
      maxStat: { type: "HP", value: 20000, current: 18000 },
      totalStat: { type: "ATK", value: 4000, current: 4100 }
    },
    rewards: [
      { type: "gems", amount: 300 },
      { type: "shards", amount: 150 }
    ]
  },
  {
    name: "Helheim's Depths",
    description: "Explore the forbidden depths of the realm of the dead.",
    energyCost: 5,
    backgroundId: "nineRealms",
    requirements: {
      maxStat: { type: "DEF", value: 2500, current: 0 },
      totalStat: { type: "HP", value: 75000, current: 0 }
    },
    rewards: [
      { type: "gems", amount: 500 },
      { type: "shards", amount: 250 }
    ]
  }
];

